import { Directive, OnInit, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Directive({})
export abstract class NgOnInitWriteBugAbstractComponent<T> implements OnInit, ControlValueAccessor {
  protected onChangeCallback!: (value: T | null) => void;
  protected onTouchedCallback!: () => void;

  // Used to workaround a bug where writeValue is called before ngOnInit()
  // https://github.com/angular/angular/issues/29218
  private ngOnInitRan: boolean = false;
  private firstValueInWriteValue: T | undefined;

  constructor(@Optional() @Self() public controlDir: NgControl) {
    if (this.controlDir) {
      this.controlDir.valueAccessor = this;
    } else {
      throw new Error(`No controlDir, it means it's missing [(ngModel)] or [formControlName] on the parent`);
    }
  }

  public registerOnChange(fn: (value: T | null) => any): void {
    this.onChangeCallback = fn;
  }

  public registerOnTouched(fn: () => any): void {
    this.onTouchedCallback = fn;
  }

  protected abstract plOnInit(): void | Promise<void>;

  public async ngOnInit(): Promise<void> {
    await this.plOnInit();

    this.ngOnInitRan = true;
    if (this.firstValueInWriteValue !== undefined) {
      this.plWriteValue(this.firstValueInWriteValue);
    }
  }

  protected abstract plWriteValue(value: T): void;

  public writeValue(value: T): void {
    if (this.ngOnInitRan) {
      this.plWriteValue(value);
    } else {
      this.firstValueInWriteValue = value;
    }
  }
}
